import { useEffect, useRef } from 'react';

const CHARS = '01アイウエカキクコサシスタチ0123456789ABCDEF<>{}[];';

export default function MatrixRain({ theme }) {
  const canvasRef = useRef(null);

  useEffect(() => {
    if (theme !== 'dark') return;

    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');

    const fontSize = 13;
    let width, height, cols, drops;

    function init() {
      width = canvas.width = window.innerWidth;
      height = canvas.height = window.innerHeight;
      cols = Math.floor(width / fontSize);
      drops = Array.from({ length: cols }, () => Math.random() * -50);
    }
    init();

    const onResize = () => init();
    window.addEventListener('resize', onResize);

    let rafId;
    let last = 0;
    const fps = 10;

    function draw(ts) {
      rafId = requestAnimationFrame(draw);
      if (ts - last < 1000 / fps) return;
      last = ts;

      ctx.fillStyle = 'rgba(2, 12, 27, 0.08)';
      ctx.fillRect(0, 0, width, height);
      ctx.font = `${fontSize}px 'JetBrains Mono', monospace`;

      for (let i = 0; i < cols; i++) {
        const char = CHARS[Math.floor(Math.random() * CHARS.length)];
        const x = i * fontSize;
        const y = drops[i] * fontSize;
        const alpha = Math.random() * 0.35 + 0.08;
        ctx.fillStyle = `rgba(14, 165, 233, ${alpha})`;
        ctx.fillText(char, x, y);

        if (y > height && Math.random() > 0.978) {
          drops[i] = 0;
        }
        drops[i] += 0.5;
      }
    }

    rafId = requestAnimationFrame(draw);

    return () => {
      cancelAnimationFrame(rafId);
      window.removeEventListener('resize', onResize);
    };
  }, [theme]);

  if (theme !== 'dark') return null;

  return (
    <canvas
      ref={canvasRef}
      aria-hidden="true"
      style={{
        position: 'fixed',
        inset: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        zIndex: 0,
        opacity: 0.18,
      }}
    />
  );
}
